export {default} from './WeightTileGraphLabel';
